import {useMemo} from 'react'
import {useSelector} from 'react-redux'

const useRulesetUsageLimit = (limit, isEnabled = true) => {
    const rulesetCount = useSelector(state => state.server_monitoring.rulesets?.length ?? 0)
    const persistedRulesetCount = useSelector(state => state.server_monitoring.persistedRulesetCount)

    return useMemo(() => {
        if (!limit || !isEnabled) return limit

        const pendingDelta = rulesetCount - persistedRulesetCount
        return {...limit, usage: Math.max(0, (limit.usage ?? 0) + pendingDelta)}
    }, [limit, rulesetCount, persistedRulesetCount, isEnabled])
}

export default useRulesetUsageLimit
